var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.values,"item-text":"text","item-value":"value","label":"Time Period","outlined":""},model:{value:(_vm.period),callback:function ($$v) {_vm.period=$$v},expression:"period"}})}
var staticRenderFns = []

export { render, staticRenderFns }